const tabDropdown = (triggers) => {
    if ( triggers.length != 0 ) {
        let lastOpenTabHeight = 0;
        let lastOpenTabNr = 0;
        let appr = 15;
        for (let i = 0; i < triggers.length; i++) {
            var wrapper = triggers[i];
            var btn = wrapper.querySelector('button');
            btn.addEventListener("click", function() {
                var parent = this.parentNode;
                var classes = parent.getAttribute('class');
                closeAllTabs();
                if ( classes.indexOf('tab-open') == -1 ) {
                    let thisTabNr = i;
                    setTimeout(()=>{
                        parent.classList.toggle('tab-open');
                        let y = window.scrollY;
                        let dist;
                        // Make sure window stays at the same place
                        // if ( thisTabNr < lastOpenTabNr ) {
                        //     dist = y - ( y - parent.offsetTop );
                        //     window.scroll( 0, y ); 
                        // } else if ( thisTabNr > lastOpenTabNr && lastOpenTabNr !== -1 ) {
                        //     dist = y - lastOpenTabHeight - ( y - parent.offsetTop ) - appr;
                        //     window.scroll( 0, dist );                             
                        // }
                    }, 100);
                } else {
                    lastOpenTabHeight = 0;
                }
            });
        }
        function closeAllTabs() {
            for (let i = 0; i < triggers.length; i++) {
                var wrapper = triggers[i];
                if ( wrapper.getAttribute('class').indexOf('tab-open') > 0 ) {
                    lastOpenTabNr = i;
                    lastOpenTabHeight = wrapper.scrollHeight;
                    wrapper.classList.remove('tab-open');
                }
            }
        }
    }
}
export { tabDropdown };